import { EventType } from './UsageEvent';
export const pickUsageTracker = (props) => {
    return (({ name, actionTrackingId, correlationTrackingId, pageTrackingId, startTime, eventDate, type, flightId, flightName, moduleName, usageUserId, }) => ({
        name,
        actionTrackingId,
        correlationTrackingId,
        pageTrackingId,
        startTime: startTime || new Date(),
        eventDate: eventDate || new Date(),
        type: type || EventType.User,
        flightId,
        flightName,
        moduleName,
        usageUserId,
    }))(props || {});
};
//# sourceMappingURL=UsageTracker.js.map